<template>
  <v-container fluid class="pa-0 ma-0 header"
    :class="{
      'cblack': isBlack,
      'screenshot': $root.isScreenshot
    }"
  >
    <v-row align="center" justify="center" class="px-2">
      <v-col cols="12" :align="isLogoLeft ? 'left' : 'center'" class="mt-4">
        <transition name="fade" mode="out-in" appear>
          <button
            v-show="!hideLogo"
            @click.stop="onLogoClick"
            class="logo"
          >
            <GucciGardenLogo
              :class="{'gucci-app': $root.isApp}"
            />
          </button>
        </transition>
      </v-col>
      <AudioPlayer v-show="!hideLanguage" class="audio-player" />
      <transition name="fade" mode="out-in" appear>
        <LangSwitcher v-show="!hideLanguage" :isBlack="isBlack" />
      </transition>
    </v-row>
  </v-container>
</template>

<script>
import AudioPlayer from './AudioPlayer.vue'
import GucciGardenLogo from '@/assets/svg/logo.svg'
import LangSwitcher from '@/atoms/LangSwitcher.vue'

export default {
  components: {
    GucciGardenLogo,
    LangSwitcher,
    AudioPlayer
  },

  data () {
    return {
      isBlack: false,
      isLogoLeft: false,
      hideLogo: false,
      hideLanguage: false,
      isHotspotOpen: false,
      ambienceAudio: null
    }
  },

  mounted () {
    this.$events.on('onHideLogo', () => {
      this.hideLogo = true
    })
    this.$events.on('onShowLogo', () => {
      this.hideLogo = false
    })
    this.$events.on('onMapOpen', () => {
      this.isBlack = true
      this.isLogoLeft = true
      this.hideLanguage = true
    })
    this.$events.on('onMapClose', () => {
      this.isBlack = false
      this.isLogoLeft = false
      this.hideLanguage = false
    })
    this.$events.on('onHotspotOpen', () => {
      this.isHotspotOpen = true
      this.isBlack = true
      this.hideLanguage = true
    })
    this.$events.on('onHotspotClose', () => {
      this.isHotspotOpen = false
      this.isBlack = false
      this.hideLanguage = false
    })
    this.$events.on('toggle-audioguide-modal', (state) => {
      if (this.$vuetify.breakpoint.xsOnly) this.isLogoLeft = state
      this.isBlack = state
      this.hideLanguage = state
    })

    if (this.$route.name === 'Home') {
      this.isBlack = true
      this.isLogoLeft = true
    }
  },

  watch: {
    isBlack () {
      if (this.$route.name === 'Home') {
        this.isBlack = true
      }
    },
    $route (to, from) {
      if (to.name === 'Home') {
        this.isBlack = true
        this.isLogoLeft = true
      } else {
        this.isBlack = false
        this.isLogoLeft = false
      }
    }
  },

  methods: {
    onLogoClick () {
      if (this.$route.name !== 'Home') {
        this.$events.emit('onLogoClick')
        this.$router.push({ name: 'Home' })
      }
    }
  }
}
</script>

<style lang="scss">
.header {
  pointer-events: none;
  position: fixed;
  z-index: 30;
  color: #fff;
  height: 90px;

  &.screenshot {
    top: 40px !important;
  }

  .lang-switcher button {
    font-size: 14px;
    text-transform: uppercase;
    font-weight: 700;
    margin: 0 8px;
    transition: color 0.4s ease-in-out;

    &:disabled,
    &:hover {
      transform: scale(1.6);
    }
  }
}

.logo {
  width: 115px;
  display: inline-block;
  line-height: 1;
  height: auto;
  position: relative;
  pointer-events: all;
  transition: all 0.2s ease-in-out;

  @include breakpoint ('xs-only') {
    width: 90px;
  }

  svg {
    width: 100%;
    height: auto;

    path {
      fill: #fff;
    }
  }

  &.gucci-app {
    top: 34px;
  }
}

.cblack {
  .logo {
    path {
      fill: #000;
    }
  }
}

.audio-player {
  cursor: pointer;
  pointer-events: auto;
  position: fixed;
  top: 34px;
  right: 115px;

  @include breakpoint ('sm-and-down') {
    top: 22px;
    left: 22px;
    right: none;
  }
}
</style>
